<template>
  <div class="hide">
    <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
      <div class="">
        <div class="">
          <p class="input-title textcolor">Type of Art</p>
          <b-form-select
            v-model="art"
            placeholder="Select Artwork"
            class="md:border-0 lg:border-0 custipshadow"
            name="city"
            disabled
          >
            <b-form-select-option :value="null" class="textcolor"
              >Please select an option</b-form-select-option
            >
            <b-form-select-option value="Poetry" class="textcolor"
              >Poetry</b-form-select-option
            >
            <b-form-select-option value="Photo" class="textcolor"
              >Photo</b-form-select-option
            >
            <b-form-select-option value="Video" class="textcolor"
              >Video</b-form-select-option
            >
            <b-form-select-option value="Prose" class="textcolor"
              >Prose</b-form-select-option
            >
          </b-form-select>
        </div>

        <div v-if="art === 'Photo' || art === 'Poetry' || art === 'Prose'">
          <div
            class="lg:mt-6 md:mt-6 mt-6"
            v-if="this.images && this.images.length !== 0"
          >
            <p class="input-title textcolor">Photo</p>
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              action="#"
              list-type="picture-card"
              accept="image/*"
              :file-list="fileListImage"
              multiple
              disabled
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>

        <div v-if="art === 'Video' || art === 'Poetry' || art === 'Prose'" class="pt-3">
          <div v-if="this.video">
            <p class="input-title textcolor">Video</p>
            <!-- <el-upload
              class="upload-demo"
              :auto-upload="false"
              action="#"
              :file-list="fileListVideo"
              accept="video/mp4,video/x-m4v,video/*"
              disabled
            >
              <b-button
                variant="primary"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                >Upload Video</b-button
              >
            </el-upload> -->
            <iframe
              class="custborderradius videowidthscreen customvideo"
              width="300"
              height="315"
              :src="getUrl(this.video)"
              title="share your work video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <!-- <div class="pt-3">OR</div> -->
          <div class="pt-3" v-if="this.videoUrl">
            <p class="input-title textcolor">Video URL</p>
            <!-- <base-input
              v-model="videoUrl"
              placeholder="Enter your Video Url"
              class="md:border-0 lg:border-0 custipshadow"
              name="videoUrl"
              disabled
              :rules="{}"
            ></base-input> -->
            <iframe
              class="custborderradius videowidthscreen"
              width="560"
              height="315"
              :src="this.videoUrl"
              title="share your work video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="mt-2">
          <p class="input-title textcolor">Name</p>
          <base-input
            v-model="firstName"
            placeholder="Enter your First Name"
            class="md:border-0 lg:border-0 custipshadow"
            name="First Name"
            disabled
            :rules="{ required: true, alpha: true }"
          ></base-input>
        </div>
        <div class="">
          <p class="input-title textcolor">Last Name</p>
          <base-input
            v-model="lastName"
            placeholder="Enter your Last Name"
            class="md:border-0 lg:border-0 custipshadow"
            name="Last Name"
            disabled
            :rules="{ required: true, alpha_dash: true }"
          ></base-input>
        </div>

        <div class="">
          <p class="input-title textcolor">Mobile No.</p>
          <base-input
            v-model="mobile"
            placeholder="Enter your Mobile No."
            class="md:border-0 lg:border-0 custipshadow"
            name="Mobile No."
            disabled
            :rules="{
              required: true,
              numeric: true,
              min: 10,
              max: 10,
            }"
          ></base-input>
        </div>

        <div class="">
          <p class="input-title textcolor">Email Address</p>
          <base-input
            v-model="email"
            placeholder="Enter your EmailID"
            class="md:border-0 lg:border-0 custipshadow"
            name="Email"
            disabled
            :rules="{ required: true, email: true }"
          ></base-input>
        </div>

        <div class="pt-3" v-if="art === 'Poetry'">
          <p class="input-title textcolor">Poetry Heading</p>
          <base-input
            v-model="poetryHeading"
            placeholder="Enter your poetry heading"
            class="md:border-0 lg:border-0 custipshadow"
            name="videoUrl"
            disabled
            :rules="{}"
          ></base-input>
        </div>

        <div class="md:mb-0 lg:mb-0 mb-9">
          <p class="input-title textcolor">Message</p>

          <quill-editor
            v-model="message"
            :options="editorOption"
            class="quill-h200px my-2 bg-white"
            disabled
          />
        </div>

        <div class="flex justify-center">
          <b-button type="button" @click="closeModal" variant="primary"
            >Close</b-button
          >
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import FileUploader from "@/components/FileUploader.vue";
import { Upload } from "element-ui";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    FileUploader,
    quillEditor,
    [Upload.name]: Upload,
  },
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      message: "",
      videoUrl: "",
      poetryHeading: "",
      video: null,
      images: [],
      art: null,
      artWorkPermission: false,
      editorOption: {
        theme: "snow",
      },

      fileListVideo: [],
      fileListImage: [],
    };
  },
  computed: {
    ...mapState("hoc", { shareWork: "shareWork" }),
    ...mapState("auth", { user: "user" }),
  },
  watch: {
    editData: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    getUrl(data) {
      return `${this.$imageURL}/${data}`;
    },
    closeModal() {
      // console.log("closeModal");
      this.$emit("closeModal");
    },
    resetForm() {
      this.art = null;
      // this.city = "";
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.mobile = "";
      this.message = "";
      this.videoUrl = "";
      this.video = null;
      this.poetryHeading = "";
      this.images = [];
      this.artWorkPermission = false;
    },
    async init() {
      if (!this.editData || !Object.keys(this.editData).length) {
        return;
      }
      this.firstName = this.editData.firstName;
      this.lastName = this.editData.lastName;
      this.email = this.editData.email;
      this.mobile = this.editData.mobile;
      this.message = this.editData.message;
      this.art = this.editData.art;
      this.videoUrl = this.editData.videoUrl ? this.editData.videoUrl : "";
      this.video = this.editData.video ? this.editData.video : null;
      const images = this.editData.images
        ? Array.isArray(this.editData.images)
          ? this.editData.images
          : [this.editData.images]
        : [];
      this.images = images;

      this.fileListImage =
        images && images.length !== 0
          ? images.map((img, index) => {
              return {
                name: `image${index + 1}`,
                url: this.getUrl(img),
              };
            })
          : [];

      this.poetryHeading = this.editData.poetryHeading
        ? this.editData.poetryHeading
        : "";

      this.artWorkPermission = this.editData.artWorkPermission;
    },
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.textcolor {
  color: #777777 !important;
}
.hide .el-upload--picture-card {
  display: none;
}
.customvideo video {
  width: 100% !important;
  height: 100% !important;
}
.custborderradius {
  border-radius: 20px;
}
.videowidthscreen {
  width: -webkit-fill-available;
  height: 300px;
}
@media (max-width: 640px) {
  .videoheART {
    width: -webkit-fill-available;

    height: 200px;
  }
}
</style>
